import { Component, Mixins, Emit, Prop } from "vue-property-decorator";
import { CalendarEvent, VForm } from "@/types";
import {
  ReceiptVisitRecord,
  RegistrationMessage,
  DefaultRegistrationMessage,
  ResetMessage,
  DefaultResetMessage
} from "#/model/receipt";
import { OfficeHistory } from "#/model/agreement";
import AxiosMixin from "@/mixins/axiosMixin";
import RulesMixin from "#/mixins/rulesMixin";
import UtilMixin from "@/mixins/utilMixin";

@Component
export default class ReceiptEditAddMedBase extends Mixins(
  AxiosMixin,
  RulesMixin,
  UtilMixin
) {
  @Prop({ default: "prefix" }) private prefix_id!: string;
  @Prop({ default: 0 }) protected readonly patientId!: number;
  @Prop({ default: () => ({}) }) protected readonly event!: CalendarEvent;
  @Prop({ default: () => ({}) })
  protected readonly receiptVisitRecord!: ReceiptVisitRecord;
  @Prop({ default: () => [] })
  protected readonly receiptVisitRecords!: ReceiptVisitRecord[];
  @Prop({ default: "" }) protected readonly yearmonth!: string;
  @Prop({ default: () => ({}) })
  protected readonly officeHistory!: OfficeHistory;
  @Prop({ default: () => ({}) }) protected readonly patientHeader!: VForm;
  @Prop({ default: 0 }) protected readonly isBilledMedical!: number;
  @Prop({ default: () => [] }) protected readonly events!: CalendarEvent[];
  @Prop({ default: false }) protected readonly homeCancerCareFlg!: boolean;
  @Prop({ default: "" }) protected readonly homeCancerCareDay!: string;
  @Prop({ default: false }) protected readonly hasInfoProvider1!: boolean;
  @Prop({ default: false }) protected readonly hasInfoProvider2!: boolean;
  @Prop({ default: false }) protected readonly hasInfoProvider3!: boolean;
  @Prop({ default: 0 }) protected readonly isHonobono!: number;
  @Prop({ default: "" }) protected readonly honobonoJigyoKnj!: string;
  @Prop({ default: 0 }) protected readonly medicalSpecialAreaDiv!: number;
  // 包括の建物に住んでいるか（包括算定可否）
  @Prop({ default: false })
  protected readonly isEnableComprehensive!: boolean;
  /** 生年月日(西暦) */
  @Prop({ default: "" }) protected readonly birthday!: string;

  //親のgetCalender動かす
  @Emit()
  protected update() {
    return;
  }

  //親画面にメッセージ表示
  @Emit()
  protected message(message: string) {
    return message;
  }

  /** 読み込み完了フラグ */
  protected isLoaded = false;

  /** 登録時メッセージ */
  protected registrationMessage: RegistrationMessage = DefaultRegistrationMessage();

  /** リセット時メッセージ */
  protected resetMessage: ResetMessage = DefaultResetMessage();

  /** サービス訪問（自費） */
  protected service_visit = false; //サービス訪問（自費）

  //介護訪問判定（介護保険があるかつ、指示書が医療扱いではないかつ、訪問記録の訪問タイプが外泊訪問以外）
  protected judgeCare(): boolean {
    let result = false;

    if (
      this.event.care_insurance.id != 0 &&
      this.event.indicate.diseases.length == 0 &&
      this.event.special_indicate.id == 0 &&
      (this.event.indicate.indicate_div == 1 ||
        this.event.indicate.is_dementia == 1) &&
      this.event.visit_record.nursing_type != 2
    ) {
      result = true;
    }

    return result;
  }

  //リセットメッセージ
  protected resetColumns(): string {
    let resetColumns = "";
    if (this.event.visit_record.is_long_care == 1) {
      resetColumns += "[長時間訪問看護（医療）]";
    }
    if (this.event.visit_record.is_emergency_care == 1) {
      resetColumns += "[緊急訪問看護（医療）]";
    }
    if (this.event.visit_record.same_p2_flg == 1) {
      resetColumns += "[同一日同一建物２人（医療）]";
    }
    if (this.event.visit_record.same_p3_flg == 1) {
      resetColumns += "[同一日同一建物３人以上（医療）]";
    }
    if (this.event.visit_record.service_time_div == 14) {
      resetColumns += "[提供時間]";
    }

    return resetColumns;
  }

  mounted(): void {
    this.registrationMessage = DefaultRegistrationMessage();
    this.$nextTick(() => {
      this.isLoaded = true;
    });
  }
}
